(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 25677:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(54148);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var react_content_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16629);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ItemLine = function(param) {
    var x = param.x, y = param.y, _squareSize = param.squareSize, squareSize = _squareSize === void 0 ? 0 : _squareSize;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
        x: x + (squareSize + 15),
        y: y,
        rx: "3",
        ry: "3",
        width: "50",
        height: "8"
    });
};
var Item = function(param) {
    var x = param.x, y = param.y, _squareSize = param.squareSize, squareSize = _squareSize === void 0 ? 60 : _squareSize;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: x,
                y: y,
                rx: "3",
                ry: "3",
                width: squareSize,
                height: squareSize
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ItemLine, {
                x: x,
                squareSize: squareSize,
                y: y + 15
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ItemLine, {
                x: x,
                squareSize: squareSize,
                y: y + 30
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ItemLine, {
                x: x,
                squareSize: squareSize,
                y: y + 45
            })
        ]
    });
};
var Column = function(param) {
    var y = param.y, x = param.x, itemsCount = param.itemsCount;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: Array.from({
            length: itemsCount
        }).map(function(v, i) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                y: y + (i + 1) * 75,
                x: x
            }, y + (i + 1) * 75);
        })
    });
};
var QuestionnairesListLoader = function(_param) {
    var _columnsCount = _param.columnsCount, columnsCount = _columnsCount === void 0 ? 2 : _columnsCount, _itemsCount = _param.itemsCount, itemsCount = _itemsCount === void 0 ? 10 : _itemsCount, props = _objectWithoutProperties(_param, [
        "columnsCount",
        "itemsCount"
    ]);
    var width = props.width ? props.width : 690;
    var height = props.height ? props.height : 680;
    width = typeof width === 'number' ? width : parseInt(width);
    var colXOffSet = width / columnsCount - 10;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, _objectSpread({
        speed: 2,
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        backgroundColor: "#f3f3f3",
        foregroundColor: "#ededed"
    }, props, {
        children: Array.from({
            length: columnsCount
        }).map(function(v, i) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Column, {
                x: i * colXOffSet,
                y: 15,
                itemsCount: itemsCount
            }, i);
        })
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (QuestionnairesListLoader);


/***/ }),

/***/ 65604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _questionnaires_OfficialQuestionnaireFormModal; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./src/components/_form/Field/index.tsx
var Field = __webpack_require__(50509);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Form.js + 15 modules
var Form = __webpack_require__(28268);
// EXTERNAL MODULE: ./src/components/_modal/FormModal/index.tsx
var FormModal = __webpack_require__(72552);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./src/functions/validation/getIsRequiredText.ts
var getIsRequiredText = __webpack_require__(42590);
// EXTERNAL MODULE: ./src/_types/api/questionnaires/QuestionnaireType.ts
var QuestionnaireType = __webpack_require__(49676);
// EXTERNAL MODULE: ./src/_types/Gender.ts
var Gender = __webpack_require__(7462);
;// CONCATENATED MODULE: ./src/components/_questionnaires/OfficialQuestionnaireFormModal/schema.ts




var schema = es/* object */.Ry().shape({
    code: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Code')),
    name: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Name')),
    type: es/* mixed */.nK().oneOf(Object.values(QuestionnaireType/* default */.Z)).required((0,getIsRequiredText/* default */.Z)('Type')),
    phase: es/* number */.Rx().required((0,getIsRequiredText/* default */.Z)('Phase')),
    gender: es/* string */.Z_().required((0,getIsRequiredText/* default */.Z)('Gender')),
    contact: es/* string */.Z_().email('Contact must be a valid email').required((0,getIsRequiredText/* default */.Z)('Email')),
    questionsStartPosition: es/* number */.Rx().typeError('First question must only contain digits').min(1, 'First question must be greater than or equal to 1.').max(1000, 'First question must be lower than or equal to 1000.').required((0,getIsRequiredText/* default */.Z)('First question')),
    description: es/* string */.Z_(),
    additionalInfo: es/* string */.Z_()
});
var schema_initialValues = {
    code: '',
    name: '',
    type: QuestionnaireType/* default.MODULE */.Z.MODULE,
    phase: 5,
    gender: Gender/* default.NEUTRAL */.Z.NEUTRAL,
    contact: '',
    questionsStartPosition: 1,
    description: '',
    additionalInfo: ''
};

// EXTERNAL MODULE: ./src/components/_form/Select/QuestionnaireTypeSelect/index.tsx
var QuestionnaireTypeSelect = __webpack_require__(58758);
// EXTERNAL MODULE: ./src/components/_form/Select/GenderSelect/index.tsx
var GenderSelect = __webpack_require__(96156);
// EXTERNAL MODULE: ./src/components/_questionnaires/OfficialQuestionnaireFormModal/officialQuestionnaireFormModal.module.scss
var officialQuestionnaireFormModal_module = __webpack_require__(75390);
var officialQuestionnaireFormModal_module_default = /*#__PURE__*/__webpack_require__.n(officialQuestionnaireFormModal_module);
// EXTERNAL MODULE: ./src/components/_form/RichTextEditor/index.tsx
var RichTextEditor = __webpack_require__(68642);
// EXTERNAL MODULE: ./src/components/_form/Select/PhaseSelect/index.tsx
var PhaseSelect = __webpack_require__(11234);
// EXTERNAL MODULE: ./src/_types/api/questionnaires/QuestionnaireKind.ts
var QuestionnaireKind = __webpack_require__(35247);
;// CONCATENATED MODULE: ./src/components/_questionnaires/OfficialQuestionnaireFormModal/index.tsx











function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var OfficialQuestionnaireFormModal = function(param1) {
    var isShowing = param1.isShowing, toggle = param1.toggle, title = param1.title, _submitButtonText = param1.submitButtonText, submitButtonText = _submitButtonText === void 0 ? 'Save' : _submitButtonText, onSubmit = param1.onSubmit, initialValues = param1.initialValues, _isResetAfterSubmit = param1.isResetAfterSubmit, isResetAfterSubmit = _isResetAfterSubmit === void 0 ? false : _isResetAfterSubmit;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal/* default */.Z, {
        title: title,
        toggle: toggle,
        isShowing: isShowing,
        validationSchema: schema,
        submitButtonText: submitButtonText,
        initialValues: initialValues || schema_initialValues,
        onSubmit: onSubmit,
        onComplete: function() {
            return toggle();
        },
        customSize: true,
        isResetAfterSubmit: isResetAfterSubmit,
        children: function(param) {
            var register = param.register, control = param.control, errors = param.formState.errors, setValue = param.setValue;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "code",
                        id: "code",
                        feedback: errors.code,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, _objectSpread({
                            isInvalid: !!errors.code,
                            placeholder: "e. g. BR"
                        }, register('code')))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "name",
                        id: "name",
                        feedback: errors.name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, _objectSpread({
                            isInvalid: !!errors.name,
                            placeholder: "e. g. Breast Module"
                        }, register('name')))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "type",
                        id: "type",
                        feedback: errors.type,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionnaireTypeSelect/* default */.Z, {
                            control: control,
                            name: "type",
                            label: "",
                            kind: QuestionnaireKind/* default.OFFICIAL */.Z.OFFICIAL
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field/* default */.Z, {
                        label: "First question",
                        id: "questionsStartPosition",
                        feedback: errors.questionsStartPosition,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, _objectSpread({
                                isInvalid: !!errors.questionsStartPosition,
                                placeholder: "1",
                                defaultValue: 1,
                                type: "number",
                                min: 1
                            }, register('questionsStartPosition'))),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (officialQuestionnaireFormModal_module_default()).helpInfoText,
                                children: "The numbering of questions starts from this number."
                            })
                        ]
                    }, "questionsStartPosition"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "testing",
                        id: "phase",
                        feedback: errors.phase,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhaseSelect/* default */.Z, {
                            control: control,
                            name: "phase",
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "gender",
                        id: "gender",
                        feedback: errors.gender,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenderSelect/* default */.Z, {
                            control: control,
                            name: "gender",
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "contact",
                        id: "contact",
                        feedback: errors.contact,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, _objectSpread({
                            type: "email"
                        }, register('contact'), {
                            placeholder: "e.g john.doe@eortc.org",
                            isInvalid: !!errors.contact
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "description",
                        id: "description",
                        feedback: errors.description,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextEditor/* default */.Z, {
                            name: "description",
                            setValue: setValue,
                            control: control,
                            placeholder: "any other information worth mentioning..."
                        })
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        label: "additional Info",
                        id: "additionalInfo",
                        feedback: errors.additionalInfo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextEditor/* default */.Z, {
                            name: "additionalInfo",
                            setValue: setValue,
                            control: control,
                            placeholder: "any other information worth mentioning..."
                        })
                    }, "additionalInfo")
                ]
            });
        }
    }));
};
/* harmony default export */ var _questionnaires_OfficialQuestionnaireFormModal = (OfficialQuestionnaireFormModal);


/***/ }),

/***/ 52867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95601);
/* harmony import */ var _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var consts_paths_api_questionnaires_getSummaries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96616);
/* harmony import */ var hooks_useApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7920);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88349);
/* harmony import */ var _consts_sharedQueryKeys__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37109);





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var useQuestionnairesSummaries = function(param) {
    var filters = param.filters;
    var ref = filters || {}, type = ref.type, kind = ref.kind;
    var api = (0,hooks_useApi__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var ref1 = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        _consts_sharedQueryKeys__WEBPACK_IMPORTED_MODULE_3__/* .questionnairesBaseQueryKey */ .iA,
        'summaries',
        {
            kind: kind
        }
    ], _asyncToGenerator(_builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var result;
        return _builds_dTaaiTbB_0_emakina_group_emakina_be_eortc_eortc_item_library_front_node_modules_pnpm_next_12_1_0_n6febsnk4nq7zxsovmf65ymnxm_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return api.get(consts_paths_api_questionnaires_getSummaries__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        params: {
                            kind: kind
                        }
                    });
                case 2:
                    result = _ctx.sent;
                    return _ctx.abrupt("return", result === null || result === void 0 ? void 0 : result.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))), questionnaires = ref1.data, error = ref1.error, isLoading = ref1.isLoading;
    return {
        questionnaires: type ? questionnaires === null || questionnaires === void 0 ? void 0 : questionnaires.filter(function(item) {
            return item.type === type;
        }) : questionnaires,
        isLoading: isLoading,
        error: error,
        type: type
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useQuestionnairesSummaries);


/***/ }),

/***/ 54148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./src/components/PageWrapper/HomePageWrapper/index.tsx + 17 modules
var HomePageWrapper = __webpack_require__(73090);
// EXTERNAL MODULE: ./src/components/_questionnaires/AlphabeticalList/index.tsx + 1 modules
var AlphabeticalList = __webpack_require__(616);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(44858);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-bootstrap@2.2.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(42359);
// EXTERNAL MODULE: ./src/hooks/useQuestionnairesSummaries/index.tsx
var useQuestionnairesSummaries = __webpack_require__(52867);
// EXTERNAL MODULE: ./src/components/OfficialQuestionnairesPage/officialQuestionnairesPage.module.scss
var officialQuestionnairesPage_module = __webpack_require__(44393);
var officialQuestionnairesPage_module_default = /*#__PURE__*/__webpack_require__.n(officialQuestionnairesPage_module);
// EXTERNAL MODULE: ./src/components/OfficialQuestionnairesPage/QuestionnaireTypesPanel/index.tsx + 1 modules
var QuestionnaireTypesPanel = __webpack_require__(23777);
// EXTERNAL MODULE: ./src/components/_questionnaires/ListLoader/index.tsx
var ListLoader = __webpack_require__(787);
// EXTERNAL MODULE: ./src/components/OfficialQuestionnairesPage/useQuestionnaireTypesPanel.tsx
var useQuestionnaireTypesPanel = __webpack_require__(53914);
// EXTERNAL MODULE: ./src/components/_questionnaires/ListItemCreate/index.tsx
var ListItemCreate = __webpack_require__(12535);
// EXTERNAL MODULE: ./src/hooks/useModal.ts
var useModal = __webpack_require__(5330);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_n6febsnk4nq7zxsovmf65ymnxm/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(95601);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/hooks/useAlerts/index.ts + 1 modules
var useAlerts = __webpack_require__(96308);
// EXTERNAL MODULE: ./src/components/_questionnaires/OfficialQuestionnaireFormModal/index.tsx + 1 modules
var OfficialQuestionnaireFormModal = __webpack_require__(65604);
// EXTERNAL MODULE: ./src/hooks/useCreateQuestionnaire/index.ts
var useCreateQuestionnaire = __webpack_require__(14149);
// EXTERNAL MODULE: ./src/functions/string/stripHtmlFromString.ts
var stripHtmlFromString = __webpack_require__(31620);
;// CONCATENATED MODULE: ./src/components/_questionnaires/OfficialQuestionnaireFormModal/CreateOfficialQuestionnaireFormModal/index.tsx






function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CreateOfficialQuestionnaireFormModal = function(param) {
    var isShowing = param.isShowing, toggle = param.toggle;
    var addSuccessAlert = (0,useAlerts/* default */.Z)().addSuccessAlert;
    var createQuestionnaire = (0,useCreateQuestionnaire/* default */.Z)().createQuestionnaire;
    var onSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(formData) {
            var additionalInfo, description, fixedAdditionalInfo, fixedDescription;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        additionalInfo = formData.additionalInfo, description = formData.description;
                        fixedAdditionalInfo = (0,stripHtmlFromString/* stripHtmlFromStringIfEmpty */.Y)(additionalInfo);
                        fixedDescription = (0,stripHtmlFromString/* stripHtmlFromStringIfEmpty */.Y)(description);
                        _ctx.next = 5;
                        return createQuestionnaire(_objectSpread({}, formData, {
                            isCustom: false,
                            description: fixedDescription,
                            additionalInfo: fixedAdditionalInfo
                        }));
                    case 5:
                        addSuccessAlert('Questionnaire created!');
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(OfficialQuestionnaireFormModal/* default */.Z, {
        isShowing: isShowing,
        toggle: toggle,
        title: "Add Questionnaire",
        onSubmit: onSubmit,
        isResetAfterSubmit: true
    }));
};
/* harmony default export */ var OfficialQuestionnaireFormModal_CreateOfficialQuestionnaireFormModal = (CreateOfficialQuestionnaireFormModal);

// EXTERNAL MODULE: ./src/hooks/useCurrentUserPermissions/index.tsx + 1 modules
var useCurrentUserPermissions = __webpack_require__(42010);
// EXTERNAL MODULE: ./src/_types/api/questionnaires/QuestionnaireKind.ts
var QuestionnaireKind = __webpack_require__(35247);
;// CONCATENATED MODULE: ./src/components/OfficialQuestionnairesPage/index.tsx













function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var OfficialQuestionnairesPage = function() {
    var ref = (0,useQuestionnaireTypesPanel/* default */.Z)(), selectedType = ref.selectedType, setSelectedType = ref.setSelectedType;
    var ref1 = _slicedToArray((0,useModal/* default */.Z)(), 2), isShowingCreateQuestionnaire = ref1[0], toggleCreateQuestionnaire = ref1[1];
    var officialQuestionnaires = (0,useCurrentUserPermissions/* default */.ZP)().officialQuestionnaires;
    var canCreateOfficialQuestionnaire = officialQuestionnaires === null || officialQuestionnaires === void 0 ? void 0 : officialQuestionnaires.canCreate;
    var ref2 = (0,useQuestionnairesSummaries/* default */.Z)({
        filters: {
            type: selectedType,
            kind: QuestionnaireKind/* default.OFFICIAL */.Z.OFFICIAL
        }
    }), questionnaires = ref2.questionnaires, isLoading = ref2.isLoading;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                sm: 7,
                children: [
                    canCreateOfficialQuestionnaire && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemCreate/* default */.Z, {
                        onClick: toggleCreateQuestionnaire,
                        text: "Add questionnaire"
                    }),
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLoader/* default */.Z, {}),
                    !isLoading && questionnaires && /*#__PURE__*/ (0,jsx_runtime.jsx)(AlphabeticalList/* default */.Z, {
                        colSm: 6,
                        questionnaires: questionnaires
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                sm: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: (officialQuestionnairesPage_module_default()).title,
                        children: [
                            "Welcome to ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " the Item Library!"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "The ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Core questionnaire"
                            }),
                            " QLQ-C30 has been developed to assess the quality of life of cancer patients."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "It is supplemented by disease-, symptom- and population-specific questionnaires called",
                            ' ',
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "modules"
                            }),
                            ". You can also find general questionnaires that can be used without the Core questionnaire, called ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "standalones"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Previous versions"
                            }),
                            " are questionnaires that have been updated."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "The ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "CAT"
                            }),
                            " groups all item banks for the Computer Adapted Testing system."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionnaireTypesPanel/* default */.Z, {
                        onSelectedChange: setSelectedType,
                        selected: selectedType
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfficialQuestionnaireFormModal_CreateOfficialQuestionnaireFormModal, {
                isShowing: isShowingCreateQuestionnaire,
                toggle: toggleCreateQuestionnaire
            })
        ]
    }));
};
/* harmony default export */ var components_OfficialQuestionnairesPage = (OfficialQuestionnairesPage);

;// CONCATENATED MODULE: ./src/pages/index.tsx



var Home = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageWrapper/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OfficialQuestionnairesPage, {})
    }));
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 44393:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"officialQuestionnairesPage_title__9CB5Q"};

/***/ }),

/***/ 75390:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"infoTextWrapper":"officialQuestionnaireFormModal_infoTextWrapper__YKzft","helpInfoText":"officialQuestionnaireFormModal_helpInfoText__muDwA"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ /* webpack/runtime/startup prefetch */
/******/ !function() {
/******/ 	__webpack_require__.O(0, [405], function() {
/******/ 		__webpack_require__.E(434);
/******/ 	}, 5);
/******/ }();
/******/ 
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [838,196,466,90,481,774,888,179], function() { return __webpack_exec__(25677); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);